import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import MultiSelectDropdown from '../../components/controls/multiselectdropdown';
import DeadlineBadge from '../../components/controls/deadlinebadge';
import JisTabButton from '../../components/controls/jisTabButton';
import PdfViewer from '../../components/controls/pdfviewer';
import JisPrepareTemplate from '../../components/core/preparetemplate';
import JisAlert from '../../components/jisalert';
import JisPrepareTemplatePlain from '../../components/core/preparetemplate_plain';

function HOPWritCases() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState(null);
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);
    const [isLiti, setIsLitiation] = useState(null);
    const [isRework, setIsRework] = useState(null);
    const [openOption, setOpenOption] = useState(false);
    const [comment, setComment] =useState('');
    const [option, setOption]=useState({});
    const [suitNumber, setSuitnumber]=useState('');
    const [selected, setSelected] = useState(new Set()); //to hold the selected 
    const [processMode, setProcessMode] = useState('');
    const [selectedClaimTypes, setSelectedClaimTypes] = useState([]);
    const [tab, setTab] = useState('pending');
    const [documents, setDocuments] = useState([]);
    const [isDocPreview, setIsDocPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState('');
    
    const [clearStatus, setClearStatus] =useState(null);

    //document template part
    const [uplinetype, setUplinetype] = useState('attest');
    const [sFile, setSFile] =useState(null);
    const [doc, setDoc] =useState(null)
    const [docline, setDocline] = useState(null);
    const [autoFill, setAutoFill] = useState([]); 
    const [claimants, setClaimants] = useState('');
    const [defendants, setDefendants] = useState('');
    const [previewPath, setPreviewPath] = useState(false);  
    const [template, setTemplate] = useState(null); 
    const [templateNotice, setTemplateNotice] = useState(null); 
    const [otherAlert, setOtherAlert]=useState({open:false})
    const [comData, setComData]=useState(null);

    const [warrant, setWarrant] = useState({id:0,warrantlines:[]}); //empty list
    const [lineIndex, setLineindex]= useState(-1); //to hold the active warrant

    useEffect(() => {
      
     if(pageIndex>=0){
        if(search!=null){
          onSearch(search);
        }
      }else{
        setPageIndex(0);
      }   
      
      if(template==null){
        if(tab=='warrants'){
          onLoadTemplate();
        }else if(tab=='notice'){
          onLoadTemplateNotice();
        }
         
         
      }
    }, [pageIndex,pageSize,search,tab]);

useEffect(() => {
      
      if(active!=null){
         let fill=[{holder:'[DEFENDANT]',value:`${active.party.firstName} ${active.party.lastName??''}`},
        {holder:'[CLAIMANTS]',value:claimants},{holder:'[DEFENDANTS]', value:defendants}
      ]
    
      setAutoFill(fill);
      }       
      //check the notice if the table is notice
      if(tab=="notice" && openOption) {
        onLoadNotice(active.id);
      } 
    }, [active]);

  const onLoadNotice= async(writid)=>{
              //for account registration
          try {
  
              setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/filing/check-notice/${writid}`, { 
                  method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
              const data = await resp.json();
              setLoading(false);
              if(data.code==0){
                  setDoc(data.docup);
                  setDocline(data.docline);
               
               
              } else if(data.code==-10){
                        setIsExpired(true);
                    }
              
              } catch (error) {
              setLoading(false);
              console.error(error);   
              }
          }  
  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/hop-post-judgement/${tab}/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

      const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

    const onContinue=(fee,ind)=>{
        //navigate(`/case-details/${caseid}`)
        setActive(fee);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }
    const onAdrLitigation=(cc,ind)=>{
        //can load the option for filing type and display

        setActive(cc);
        setIndex(ind);
        setOpenOption(true);
          setOption({caseId:cc.case?.caseId,caseCategoryId:cc.case?.caseCategoryId, divisionId:cc.case?.divisionId});
    }

   const onSave=async(e)=>{
             e.preventDefault();
             console.log('on Save');
            if(tab=='warrants'){
              console.log('in warrant');
               if(warrant?.warrantlines.length==0){
               setErr('Please click the "Add Warrant" to prepare warrant');
               return;
             }
               SavePreparedWarrant(active.id);
               return;
            }else if(tab=="notice"){
              SaveNoticeOfAttachment();
              return;
            }
             

             if(clearStatus==null){
               setErr('Please select the Approval Option--');
               return;
             }
             if(clearStatus==false && isRework==null){
               setErr('Please select the Reject Option');
               return;
             }

              var approve={...option,writId:active.id, clearStatus,isRework };
               
            
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/post-judgement-clear/${active.id}`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setOpenOption(false)
                const ft=cases.filter((_, i) => i !== index)
                setCases(ft );
                if(isLiti==false){
                     setAlert({open:true, title:'Option', subtitle:'rejected successfully'});
                }else{
                    setAlert({open:true, title:'Option', subtitle:'accepted successfully'});
                }
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 
     
   
const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}
 const onChangeTab=(t)=>{
      setTab(t);
      setPageIndex(0);
    }

    //for doc or template
 const handleUploadChange =async (e, index) => {
 
       // const files = e.target.files;
       const inputname=`file-upload-${index}`;
       const input = document.getElementById(inputname);
        console.log(`the input id ${inputname}`)
        const files = input?.files;

        if (!files) return;

        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={ path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

      // setSFile(a);

        var _warlines=warrant.warrantlines;
   const newlines= _warlines.map((item, i) => i === index ? { ...item, sFile: a } : item)
    setWarrant({...warrant,warrantlines:newlines});
      console.log(newlines);
    };
    const noticeUploadChange =async (e) => {
 
        const files = e.target.files;
      
       // const files = input?.files;

        if (!files) return;

        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={ path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

       setSFile(a);

        
    };

    const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }


    const SavePreparedWarrant= async(writid)=>{
        const warranturl=`${Constants.apiUrl}/filing/prepare-warrant/${writid}`
        console.log('in Save Prepare')
        const lines = warrant.warrantlines.map((opt) => ({
              id: opt.id,
              doc: opt.sFile?.base64??null,
              base64Ext: opt.sFile?.base64Ext??null,
              uplinetype:opt.uplinetype,
              location: opt.location,
              warranttype:opt.warranttype,
              filename:opt.sFile?.filename??null,
              docExt: opt.sFile?.base64Ext??null,
              templateJson:opt.holdervalues?btoa(JSON.stringify(opt.holdervalues)):null ,
              html:opt?.holdervalues? Constants.b64encode(opt.html):null,
              templateId:template!=null?template.id:null,
              templateTitle:template!=null?template.title:null
            })); 

        var _warrant={
                writId: active.id,
                comment,
                lines,
                
               
                }
            
            console.log('data to be sent');
            console.log(_warrant);  


      //  setFlowError('');

            // Sending the FormData using fetch
            setLoading(true);
            fetch(warranturl, {
            method: 'POST',
            body: JSON.stringify(_warrant),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                  setOpenOption(false);
                const ft=cases.filter((_, i) => i !== index)
                setCases(ft);
                    setOtherAlert({open:true, title:'Prepare Warrant', subtitle:'Warrant Prepared', onOk:onOkUpload})

                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }  
    const SaveNoticeOfAttachment= async(writid)=>{
        const approveurl=`${Constants.apiUrl}/filing/post-judgement-clear/${active.id}`
        console.log('in Save Prepare')
        if(uplinetype!="template" && sFile==null){
               setErr('Please select the prepared Notice of Attachment');
               return;
             }

         var approve={...option,writId:active.id, clearStatus,uplinetype,
          doc: sFile?.base64??null,
          docuplineId: docline.id,
              base64Ext: sFile?.base64Ext??null,
              uplinetype:uplinetype,
               filename:sFile?.filename??null,
               templateJson:comData?.holdervalues?btoa(JSON.stringify(comData.holdervalues)):null ,
              html:comData?.html ? Constants.b64encode(comData.html):null,
            templateId:templateNotice!=null?templateNotice.id:null,
              templateTitle:templateNotice!=null?templateNotice.title:null
         };
            
            console.log('data to be sent');
            console.log(approve);  


      //  setFlowError('');

            // Sending the FormData using fetch
            setLoading(true);
            fetch(approveurl, {
            method: 'POST',
            body: JSON.stringify(approve),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                  setOpenOption(false);
                const ft=cases.filter((_, i) => i !== index)
                setCases(ft);
                    setOtherAlert({open:true, title:'Notice of attachment', subtitle:'Notice of attachment uploaded successfully', onOk:onOkUpload})

                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }  

const onPrepareDone=(e)=>{
 
//this is only one upload at once
 
}
 
const onOkUpload=()=>{
  setOtherAlert({open:false});
 // onPrepareDone({source:'upload'});
  //reload the warrant
  setOpenOption(false);
}
const onInstumentAppended=(e)=>{
    //after saving of instrument, this is what you get
      if(e.code==0){
              //saved already   
          }
  }

  //warrant special (smiles)
  const onAddWarrant=()=>{
    var war={id:0,location:'',uplinetype:null,warranttype:'debt'};
    setWarrant({...warrant,warrantlines:[...warrant.warrantlines,war]});
  }

  const onChangeWarrantLine = (index, key, value) => {

    var _warlines=warrant.warrantlines;
   const newlines= _warlines.map((item, i) => i === index ? { ...item, [key]: value } : item)
    setWarrant({...warrant,warrantlines:newlines});
  };

  const onChangePrepare=(holdervalues,html,isLegal,index)=>{
     
        var _warlines=warrant.warrantlines;
   const newlines= _warlines.map((item, i) => i === index ? { ...item, html,holdervalues } : item)
    setWarrant({...warrant,warrantlines:newlines});
      console.log(newlines);   

  }
   const onChangePrepareNotice=(holdervalues,html,isLegal)=>{
     
    setComData({html,holdervalues });

  }

  const onLoadTemplate= async()=>{
              //for account registration
          try {
  
              setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/filing/load-special-template/warrant`, { 
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
              const data = await resp.json();
              setLoading(false);
              if(data.code==0){
                  
                setTemplate(data.temp);
                
                
              } else if(data.code==-10){
                        setIsExpired(true);
                    }
              
              } catch (error) {
              setLoading(false);
              console.error(error);   
              }
          }
const onLoadTemplateNotice= async()=>{
              //for account registration
          try {
  
              setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/filing/load-special-template/notice-of-attachment-41`, { 
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
              const data = await resp.json();
              setLoading(false);
              if(data.code==0){
                  
                setTemplateNotice(data.temp);
                
                
              } else if(data.code==-10){
                        setIsExpired(true);
                    }
              
              } catch (error) {
              setLoading(false);
              console.error(error);   
              }
          }
  return (
    <div>
     
      <CaseSearch onSearch={onSearch} frequentData={frequentData} />

      <div className='tab_body'>
      <div className='tab_section'>
      <JisTabButton isActive={tab=='pending'}   title="Pending" 
       isRoleBased={false} onClick={()=> onChangeTab('pending')}/>

      <JisTabButton isActive={tab=='rework'}   title="Rework Cases" 
       isRoleBased={false} onClick={()=> onChangeTab('rework')}/>

       <JisTabButton isActive={tab=='reject'}   title="Rejected Cases" 
       isRoleBased={false} onClick={()=> onChangeTab('reject')}/>

      <JisTabButton isActive={tab=='warrants'}   title="Ready For Warrant" 
       isRoleBased={false} onClick={()=> onChangeTab('warrants')}/>
       
       <JisTabButton isActive={tab=='notice'}   title="Notice of Attachment" 
       isRoleBased={false} onClick={()=> onChangeTab('notice')}/>

      </div>
      <div className='tab_view'>

      </div>
    </div>

{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases">
  <span>Head Of Process Cases </span><span className='total'>{count}</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Party</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Date Filed</th>
      <th>Status Level</th>
      
      {tab!="processed" &&  <th>SLA</th>}
      <th>Details</th>
      
      {tab!="processed" && <th>Action</th>}
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => {
      const cc=Constants.getSlaTimeLeft(opt.slaExpire);
      return (
       <tr key={index}  >
      <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.case?.caseCategoryId)?.colour}`}}>{opt.case?.caseNumber}</td>
      <td>{opt.case?.caseTitle}</td>
      <td>{opt.party.firstName} {opt.party.lastName}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt.case?.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt.case?.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
       <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
     {tab!="processed" &&  <td><DeadlineBadge dateString={opt.slaExpire} /> </td>} 
     
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
    {tab!="processed" &&  <td><JisButton variant='plain' onClick={()=>onAdrLitigation(opt,index)}>Clear</JisButton></td>} 
   
    </tr>
    )})} 
  </tbody>
</table>
{cases?.length>0 && <Pagenated size={pageSize} total={count} maxPage={20}  onPick={onPagePick}  onChangePageSize={(k)=>setPageSize(k)}/>}    
</div>}
<BackLoader open={loading} />
 {otherAlert.open && <JisAlert {...otherAlert} />}
{openCase && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
          </div>
</JisDialogForm>}

      {openOption && <JisDialogForm title="Clear Options" onClose={()=>setOpenOption(false)}>
                    <form onSubmit={onSave}>
                        <div>
                          {tab=="warrants" && <>
                           <div> Head of Process Will Warrant by Available Location. It will now be forwarded to  Trial Judge to Sign </div>
                           <div style={{textAlign:'right'}}>
                            <JisButton onClick={onAddWarrant}>Add Warant ({warrant?.warrantlines.length})</JisButton>
                           </div>
 {warrant?.warrantlines.map((line, index) => {
     
      return (
       <div key={index}  >
      <div style={{ paddingLeft:16}}>
           <div style={{display:'flex'}}>
             <div  className="input-group" >
                  <label> Warrant Location</label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="locate" />
                    <input
                      placeholder='Warrant Location'
                      value={line.location}
                      onChange={(e) => onChangeWarrantLine(index, 'location', e.target.value)}
                      required={true}
                      
                    />
                  </div>
              </div> 
              <div className="select-group">
                    <label>
                      Warrant Type:  
                    </label>
                    <select name="warranttype" value={line.warranttype}  onChange={(e) => onChangeWarrantLine(index, 'warranttype', e.target.value)} required>
                      <option value='debt'>Judgment debt</option>
                      <option value='Possession'>Possession</option>
                      <option value='both'>Possession And Judgment debt</option>
                      
                    </select>  
                </div>
           </div>
         
          <div style={{display:'flex'}}>
             
              
            <div style={{display:'flex', maxWidth:450}}> 
                <span style={{padding:8}}>Type Of Document </span> 
                <div className={`selected ${line.uplinetype=='template'?'active':''}`} onClick={()=>onChangeWarrantLine(index, 'uplinetype', 'template')}>Template</div>
                <div className={`selected ${line.uplinetype=='attest'?'active':''}`} onClick={()=>onChangeWarrantLine(index, 'uplinetype', 'attest') }>Upload Document</div>
              </div>
            </div>  
            
           { line.uplinetype!=null && line.uplinetype!='template' && 
           <div style={{display:'flex'}}>
               <div className="btn-upload">
                <input
                  type="file"
                  accept="application/pdf"
                  id={`file-upload-${index}`}
                  onChange={(e) => handleUploadChange(e,index)}
                />
                <label
                  htmlFor={`file-upload-${index}`}
                  title={line.sFile?.filename}
                >
                  {line.sFile?.path == null
                    ? 'Choose File'
                    : Constants.ReduceString(
                       line.sFile?.filename,
                        30
                      )}
                </label>
               {/*  {line.sFile?.path!=null && <JisButton onClick={()=> onPreview(line.sFile)}>Preview</JisButton>} */}
              </div> 
             {/*  <div>
              {line.sFile?.path!=null && <JisButton onClick={onSaveFile}>Save File</JisButton>}   
              </div> */}

            </div>} 

           <div className='view-doc'>
              { template!=null && line.uplinetype=='template' &&
              <JisPrepareTemplatePlain templatedoc={{...doc,upline:docline,template:template}} docInfo={active.case} 
              isLegal={true} onInstumentAppended={onInstumentAppended}  doctype="warrant" autoFill={autoFill}
              onChange={(holdervalues,html,isLegal)=>onChangePrepare(holdervalues,html,isLegal,index)}
               />}

             

            </div>

        </div>
    </div>
    )})}
        

                          </>}
                          {tab=="notice" && <>
                           <div>Submit Notice of Attachment and forwards the case to  the Deputy Sheriff (DS) to assign Execution Sheriff </div>
                          <div style={{display:'flex'}}>
             
              
            <div style={{display:'flex', maxWidth:450}}> 
                <span style={{padding:8}}>Type Of Document </span> 
                <div className={`selected ${uplinetype=='template'?'active':''}`} onClick={()=>setUplinetype('template')}>Template</div>
                <div className={`selected ${uplinetype=='attest'?'active':''}`} onClick={()=>setUplinetype( 'attest') }>Upload Document</div>
              </div>
            </div>  
            
           { uplinetype!=null && uplinetype!='template' && 
           <div style={{display:'flex'}}>
               <div className="btn-upload">
                <input
                  type="file"
                  accept="application/pdf"
                  id={`notice-upload`}
                  onChange={(e) => noticeUploadChange(e)}
                />
                <label
                  htmlFor={`notice-upload`}
                  title={sFile?.filename}
                >
                  {sFile?.path == null
                    ? 'Choose File'
                    : Constants.ReduceString(
                       sFile?.filename,
                        30
                      )}
                </label>
              
              </div> 
             

            </div>} 

           <div className='view-doc'>
              { templateNotice!=null && uplinetype=='template' &&
              <JisPrepareTemplatePlain templatedoc={{...doc,upline:docline,template:templateNotice}} docInfo={active.case} 
              isLegal={true} onInstumentAppended={onInstumentAppended}  doctype="warrant" autoFill={autoFill}
              onChange={(holdervalues,html,isLegal)=>onChangePrepareNotice(holdervalues,html,isLegal)}
               />}

             

             
             {/*  {doc!=null && docline!=null &&   uplinetype!='template' &&
             <div className='view-temp'>
              <div style={{width:'100%',minHeight:500}}>
                <PdfViewer   pdfUrl={previewPath} /></div>
            </div>
              } */}

            </div>
                          </>}
                          {tab=="pending" && <>
                         <div> forwards the case to  the Deputy Sheriff (DS) and Head of Appeal(HOA) </div>
       <JisYesNo  label= {`This case ( ${active?.case?.caseNumber}) is`} value={clearStatus} yes="Accept" no="Rework/Reject"  onChange={(e)=>setClearStatus(e) } applyButtonStyle={true}/> 
       {clearStatus==false && 
        <JisYesNo  label= {`The mode either Rework or Reject`} value={isRework} yes="Re-work" no=" Reject"  onChange={(e)=>setIsRework(e) } applyButtonStyle={true}/> 
       } 
                          </>}
   
                            <div  className="input-group">
                                <label>Comment <span className="required">*</span> </label>
                                <div className='input-wrapper'>
                                    <DynamicIcon iname="group" />
                                    <textarea placeholder=' Comment' name='comment' required={true}  value={option.comment}
                            onChange={onOptionChange}  />
                                </div>
                            </div> 
                           {err!="" && <div className='error'>{err}</div>}
                           
                         
                           <div className='groupbtn'>
                             <JisButton type="submit">Save </JisButton>  
                            <JisButton type="button" variant='outline' onClick={()=> setOpenOption(false)}>Cancel </JisButton>             
                           </div>
                           
                          
                            
                        </div>
                    </form>
            </JisDialogForm>}  

            {isDocPreview && previewUrl!='' && <JisDialogForm title="Document Preview" onClose={() =>setIsDocPreview(false)}>
                      <div>
                        <div style={{height:'90vh'}}> <PdfViewer pdfUrl={previewUrl}/>
                                           
                                            </div>
                      </div>
            </JisDialogForm>}  
            {isPreview && <JisDialogForm title="Document Preview" onClose={() =>setIsPreview(false)}>
                      <div>
                        <div style={{height:'90vh'}}> <PdfViewer pdfUrl={previewUrl}/>
                                           
                                            </div>
                      </div>
            </JisDialogForm>}
    </div>
  );
}

export default HOPWritCases;